import { useState } from 'react';
import Statement from './Statement.jsx';
import { TransactionForm } from './Exchange.jsx';
import { useApi } from '../lib/hooks.js';
import { useToast } from '../lib/toast.jsx';
import { t } from '../lib/i18n.js';
import { IconExchange } from '../components/Icons.jsx';

/**
 * The per-company exchange statement. It is the same shared statement page
 * every other party type uses (same ledger table, same PDF and WhatsApp
 * buttons) with one difference: the header action opens the kind-aware
 * transaction form instead of the generic payment form, because an exchange
 * company's balance never moves through a plain payment.
 */
export default function ExchangeStatement() {
  const [open, setOpen] = useState(false);
  const companies = useApi('/api/exchange/companies', { include_inactive: true });
  const toast = useToast();

  return (
    <>
      <Statement
        type="exchange"
        headerAction={({ party, reload }) =>
          party && (
            <>
              <button type="button" className="btn btn-sm btn-primary no-print" onClick={() => setOpen(true)}>
                <IconExchange /> {t.exchange.newTransaction}
              </button>
              {open && (
                <TransactionForm
                  companies={companies.data || []}
                  initialCompanyId={party.id}
                  onClose={() => setOpen(false)}
                  onSaved={() => {
                    setOpen(false);
                    toast.success(t.exchange.transactionSaved);
                    reload();
                  }}
                />
              )}
            </>
          )
        }
      />
    </>
  );
}
